import { all } from 'redux-saga/effects'

// Site sagas
import watchProfile from '../containers/SignInPage/saga'
import watchProfileTeachers from '../containers/ProfileTeachersPage/saga'
import watchProfileParents from '../containers/ProfileParentsPage/saga'
import watchProfileContests from '../containers/ProfileContestsPage/saga'
import watchProfileContestWork from '../containers/ProfileContestsWorkPage/saga'
import watchProfileContestsWorksList from '../containers/ProfileContestsWorksListPage/saga'
import watchProfileAchievements from '../containers/ProfileAchievementsPage/saga'
import watchProfileExpertCabinet from '../containers/ProfileExpertCabinetPage/saga'
import watchNotion from '../containers/NotionPage/saga'
import watchCoursesList from '../containers/CoursesListPage/saga'
import watchCoursePage from '../containers/CoursePage/saga'
import watchModulePage from '../containers/ModulePage/saga'
import watchModuleScreen from '../containers/ModuleScreenPage/saga'
import watchModuleLessonPage from '../containers/LessonPage/saga'

// Admin sagas
import watchAdminCourses from '../containers/AdminCoursesListPage/saga'
import watchAdminCourseCreate from '../containers/AdminCourseCreatePage/saga'
import watchAdminCourseEdit from '../containers/AdminCourseEditPage/saga'
import watchAdminLessons from '../containers/AdminLessonsListPage/saga'
import watchAdminLessonCreate from '../containers/AdminLessonCreatePage/saga'
import watchAdminLessonEdit from '../containers/AdminLessonEditPage/saga'
import watchAdminLessonBlocks from '../containers/AdminLessonBlocksPage/saga'
import watchAdminModuleEdit from '../containers/AdminModuleEditPage/saga'
import watchAdminModuleCreate from '../containers/AdminModuleCreatePage/saga'
import watchAdminModulesListPage from '../containers/AdminModulesListPage/saga'
import watchAdminModuleScreenBlocks from '../containers/AdminModuleScreenBlocks/saga'
import watchAdminBlockEdit from '../containers/AdminBlockEditPage/saga'
import watchAdminMapEdit from '../containers/AdminMapEditPage/saga'
import watchAdminAchievements from '../containers/AdminAchievementsPage/saga'
import watchAdminAchievementEdit from '../containers/AdminAchievementEditPage/saga'
import watchAdminUsers from '../containers/AdminUsersPage/saga'
import watchAdminUserView from '../containers/AdminUserViewPage/saga'

export default function* rootSaga() {
  yield all([
    watchProfile(),
    watchProfileTeachers(),
    watchProfileParents(),
    watchProfileContests(),
    watchProfileContestWork(),
    watchProfileContestsWorksList(),
    watchProfileAchievements(),
    watchProfileExpertCabinet(),
    watchNotion(),
    watchCoursesList(),
    watchCoursePage(),
    watchModulePage(),
    watchModuleScreen(),
    watchModuleLessonPage(),
    watchAdminCourses(),
    watchAdminCourseCreate(),
    watchAdminCourseEdit(),
    watchAdminLessons(),
    watchAdminLessonCreate(),
    watchAdminLessonEdit(),
    watchAdminLessonBlocks(),
    watchAdminModuleEdit(),
    watchAdminModuleCreate(),
    watchAdminModulesListPage(),
    watchAdminModuleScreenBlocks(),
    watchAdminBlockEdit(),
    watchAdminMapEdit(),
    watchAdminAchievements(),
    watchAdminAchievementEdit(),
    watchAdminUsers(),
    watchAdminUserView(),
  ])
}
